module.exports = __webpack_public_path__ + "img/world-map-3.c587e026.jpg";